module.exports = "/images/vendor/flag-icon-css/flags/1x1/my.svg?263aea34bcf7dfb6c02b2c485359e4a2";